import { render } from "./ChatList.vue?vue&type=template&id=1bf551c5&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"

import "./ChatList.vue?vue&type=style&index=0&id=1bf551c5&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf551c5"]])

export default __exports__